import arrowIcon from "../../images/arrow-in-circle.svg";
import PaymentHeader from "../PaymentHeader";
import React from "react";
import styles from "./PaymentMethodsHeader.module.css";
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "../../lib/hooks";

type Props = {
    backPromptLabel: string;
    to: string;
};

export function PaymentMethodsHeader(props: Props) {
    const navigate = useNavigate();
    const customerName = useAppSelector((state) => {
        if (state.pos.currentOrder.guestName) {
            return state.pos.currentOrder.guestName;
        } else if (state.pos.currentOrder.pagerNumber) {
            return state.pos.currentOrder.pagerNumber.toString();
        } else {
            return null;
        }
    });

    return (
        <div className={styles.headerContainer}>
            <PaymentHeader
                showCheckoutReturnPrompt={false}
                customerName={customerName}
            />
            <div className={styles.backPrompt}>
                <button
                    className={styles.backPromptButton}
                    onClick={() => {
                        navigate(props.to);
                    }}>
                    <img src={arrowIcon} alt="" />
                    <div className={styles.backPromptText}>
                        {props.backPromptLabel}
                    </div>
                </button>
            </div>
        </div>
    );
}
